import React from 'react';
import { Table, Tag, Toast } from '@douyinfe/semi-ui';
import { stringToColor } from '../helpers/render';
import { copy } from '../helpers/utils';
import { formatCompact, formatFull } from '../helpers/usage';
import CollapsiblePanel from './CollapsiblePanel';

// 紧凑数字 + 悬浮完整值，避免表格过宽
const compactNum = (v) => (
  <span title={formatFull(v)}>{formatCompact(v)}</span>
);

// 按模型分组统计表（含花费占比内嵌条）
const ModelStatsTable = ({ modelStats }) => {
  const copyModel = async (name) => {
    if (await copy(name)) Toast.success('已复制：' + name);
  };

  const columns = [
    {
      title: '模型',
      dataIndex: 'model',
      render: (text) => (
        <Tag
          color={stringToColor(text)}
          size="large"
          style={{ cursor: 'pointer' }}
          onClick={() => copyModel(text)}
        >
          {text}
        </Tag>
      ),
      sorter: (a, b) => ('' + a.model).localeCompare(b.model),
    },
    {
      title: '请求数',
      dataIndex: 'requests',
      render: formatFull,
      sorter: (a, b) => a.requests - b.requests,
    },
    {
      title: '提示',
      dataIndex: 'promptTokens',
      render: compactNum,
      sorter: (a, b) => a.promptTokens - b.promptTokens,
    },
    {
      title: '补全',
      dataIndex: 'completionTokens',
      render: compactNum,
      sorter: (a, b) => a.completionTokens - b.completionTokens,
    },
    {
      title: '缓存读取',
      dataIndex: 'cacheRead',
      render: compactNum,
      sorter: (a, b) => a.cacheRead - b.cacheRead,
    },
    {
      title: '缓存写入',
      dataIndex: 'cacheWrite',
      render: compactNum,
      sorter: (a, b) => a.cacheWrite - b.cacheWrite,
    },
    {
      title: '总 Tokens',
      dataIndex: 'totalTokens',
      render: compactNum,
      sorter: (a, b) => a.totalTokens - b.totalTokens,
    },
    {
      title: '花费',
      dataIndex: 'usd',
      render: (v) => v.toFixed(2),
      sorter: (a, b) => a.usd - b.usd,
      defaultSortOrder: 'descend',
    },
    {
      title: '花费占比',
      dataIndex: 'share',
      width: 150,
      render: (share) => (
        <div className="share-cell">
          <div className="share-bar-track">
            <div
              className="share-bar-fill"
              style={{ width: `${Math.max(share * 100, share > 0 ? 1 : 0).toFixed(1)}%` }}
            />
          </div>
          <span className="share-num">{(share * 100).toFixed(1)}%</span>
        </div>
      ),
      sorter: (a, b) => a.share - b.share,
    },
  ];

  return (
    <CollapsiblePanel
      className="fade-up fade-up-3"
      storageKey="collapse:model-stats"
      title="按模型统计"
      sub={modelStats.length > 0 ? `${modelStats.length} 个模型` : ''}
    >
      {modelStats.length === 0 ? (
        <div className="chart-empty">暂无数据</div>
      ) : (
        <Table
          columns={columns}
          dataSource={modelStats}
          rowKey="model"
          size="small"
          pagination={{ pageSize: 10, hideOnSinglePage: true }}
          scroll={{ x: 'max-content' }}
        />
      )}
    </CollapsiblePanel>
  );
};

export default ModelStatsTable;
